var $ = require("jquery");
$(document).ready(function () {
  $("[data-nav]").on("click", function (e) {
    e.preventDefault();
    $(this).parent().addClass("active").siblings().removeClass("active");
    $("html, body").animate({
      scrollTop: $($(this).data("nav")).offset().top - 70
    }, 500);
  });
  $(window).on("scroll", function () {
    $(".section").each(function () {
      if ($(window).scrollTop() >= $(this).offset().top - 100) {
        //find link that data-nav == the section id
        $('[data-nav="#' + $(this).attr("id") + '"' + ']').parent().addClass("active").siblings().removeClass(
          "active");
      }
    });
  });

});

// add margin bottom to footer if subscribe alert exists
window.addEventListener("load", function () {
  var footerElment = document.getElementById("footer"),
    subscribeAlert = document.getElementById("subscribe-alert"),
    cookiesAlert = document.getElementById("cookies-alert");

  if (cookiesAlert) {
    footerElment.style.marginBottom = cookiesAlert.clientHeight + 'px';
    // remove cookiesAlert
    cookiesAlert.querySelector("#confirm-cookies-btn").addEventListener("click", function () {
      cookiesAlert.remove();
      if (subscribeAlert && window.innerWidth <= 575.98) {
        footerElment.style.marginBottom = subscribeAlert.clientHeight + 'px';
      } else {
        footerElment.style.marginBottom = '0';
      }
    });
  } else if (subscribeAlert && window.innerWidth <= 575.98) {
    footerElment.style.marginBottom = subscribeAlert.clientHeight + 'px';
  }
});